module.exports = __webpack_public_path__ + "assets/images/img/Profile-01.1e4e145af19ec324d2edece5cbba6f3f.png";